// export const personInfo = state => state.personInfo

// export const intention = state => state.intention

// export const cities = state => state.cities

// export const currentIndex = state => state.currentIndex

// export const currentCity = state => {
//   return state.cities[state.currentIndex] || {}
// }

// export const isMembership = state => state.isMembership
// export const Membership = state => state.membership

// export const buyMemeberData = state => state.buyMemeberData

// export const udeskOnlineUrl = state => state.udeskOnlineUrl

import {
  NORMAL,
  MEMBER_STATE_DATA,
} from '@/assets/js/const'

export const memberPopupData = (state) => {

  const memberState = state.purchaseRecordData?.state || NORMAL

  return MEMBER_STATE_DATA[memberState]
}
